import { useEffect, useState } from 'react';
import { getUserId } from '@/infrastructure/auth';
import { getProductId } from '@/infrastructure/product-info';
import { ToggleType } from '@/presentation/components/toggle/index';
import { ToggleConfig } from '@/presentation/components/toggle/service';
import { Toggle } from '@/presentation/components/toggle/toggle';

export default function useToggle(
  configName: string,
  type: ToggleType[],
  customValidator?: (config: ToggleConfig) => void,
) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    const toggle = new Toggle();
    const enable = await toggle.isEnable(configName, type, {
      user: getUserId(),
      appId: getProductId(),
      customValidator,
    });
    setEnabled(enable);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  return [enabled, loading];
}
